<template>
  <v-card class="mt-4">
    <v-card-title class="d-flex flex-wrap align-center">
      <v-icon left color="error">mdi-timer-stop-outline</v-icon>
      <div>
        <span>{{ $t('autostop.title') }}</span>
        <div class="text-caption text--secondary">{{ $t('autostop.subtitle') }}</div>
      </div>
    </v-card-title>

    <v-card-text>
      <v-row align="center" dense>
        <v-col cols="12" sm="4" md="3">
          <v-menu
            ref="menuOra"
            v-model="menuOra"
            :close-on-content-click="false"
            :return-value.sync="ora"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                v-on="on"
                :value="ora || $t('autostop.off')"
                :label="$t('autostop.time')"
                prepend-inner-icon="mdi-clock-outline"
                readonly
                outlined
                dense
                hide-details
              />
            </template>
            <v-time-picker
              v-if="menuOra"
              v-model="ora"
              format="24hr"
              full-width
              @click:minute="$refs.menuOra.save(ora)"
            />
          </v-menu>
        </v-col>

        <v-col cols="12" sm="8" md="9" class="d-flex align-center flex-wrap" style="gap: 8px">
          <v-btn color="primary" depressed :loading="duke" :disabled="ora === oraERuajtur" @click="ruaj">
            {{ $t('actions.save') }}
          </v-btn>
          <v-btn v-if="oraERuajtur" text small :disabled="duke" @click="hiq">
            {{ $t('autostop.clear') }}
          </v-btn>
          <v-spacer />
          <v-btn text small color="primary" @click="hapHistorikun">
            <v-icon left size="18">mdi-history</v-icon>
            {{ $t('autostop.history') }}
          </v-btn>
        </v-col>
      </v-row>

      <v-expand-transition>
        <div v-show="historikuHapur" class="mt-4">
          <div class="text-caption text--secondary mb-1">{{ $t('autostop.last_30_days') }}</div>
          <v-data-table
            :headers="kolonat"
            :items="historiku"
            :loading="historikuDuke"
            :no-data-text="$t('autostop.none')"
            :items-per-page="10"
            dense
          >
            <template v-slot:item.started_at="{ item }">
              {{ item.started_at | moment('DD/MM/YYYY HH:mm') }}
            </template>
            <template v-slot:item.stopped_at="{ item }">
              {{ item.stopped_at | moment('DD/MM/YYYY HH:mm') }}
            </template>
          </v-data-table>
        </div>
      </v-expand-transition>
    </v-card-text>
  </v-card>
</template>

<script>
/**
 * Ora ne te cilen mbyllen vetvetiu udhetimet e harruara.
 *
 * Shoferi ndonjehere nuk e shtyp "Ndalo" dhe udhetimi mbetet hapur gjithe
 * naten. Ketu shkolla cakton oren, dhe me poshte sheh kujt i ka ndodhur.
 */
import axios from 'axios';
import { mesazhiIGabimit } from '@/utils/error-message';

export default {
  data() {
    return {
      ora: null,
      oraERuajtur: null,
      menuOra: false,
      duke: false,
      historikuHapur: false,
      historiku: [],
      historikuDuke: false,
    };
  },

  computed: {
    kolonat() {
      return [
        { text: this.$t('autostop.driver'), value: 'driver' },
        { text: this.$t('autostop.bus'), value: 'bus' },
        { text: this.$t('autostop.started'), value: 'started_at' },
        { text: this.$t('autostop.stopped'), value: 'stopped_at' },
      ];
    },
  },

  mounted() {
    this.ngarko();
  },

  methods: {
    async ngarko() {
      try {
        const { data } = await axios.get('/auto-stop');
        this.ora = data.auto_stop_rides_at;
        this.oraERuajtur = data.auto_stop_rides_at;
      } catch (e) {
        // Nje deshtim ketu nuk duhet ta prishe ballinen.
      }
    },

    async ruaj() {
      this.duke = true;
      try {
        const { data } = await axios.put('/auto-stop', { auto_stop_rides_at: this.ora || null });
        this.oraERuajtur = data.auto_stop_rides_at;
        this.$notify({ title: 'OK', text: data.message, type: 'success' });
      } catch (e) {
        this.$notify({ title: 'Error', text: mesazhiIGabimit(e), type: 'error' });
      } finally {
        this.duke = false;
      }
    },

    async hiq() {
      this.ora = null;
      await this.ruaj();
    },

    hapHistorikun() {
      this.historikuHapur = !this.historikuHapur;
      if (this.historikuHapur && !this.historiku.length) this.ngarkoHistorikun();
    },

    async ngarkoHistorikun() {
      this.historikuDuke = true;
      try {
        const { data } = await axios.get('/auto-stop/history', { params: { days: 30 } });
        this.historiku = data.rides;
      } catch (e) {
        this.$notify({ title: 'Error', text: mesazhiIGabimit(e), type: 'error' });
      } finally {
        this.historikuDuke = false;
      }
    },
  },
};
</script>
